/**
 * Smart link opener: new tab on desktop, same window on mobile.
 * Mobile browsers often block window.open or make new tabs confusing.
 */
const isMobile = () => /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;

export const openLink = (url) => {
  if (!url) return;
  if (isMobile()) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
};
